import type { ResolverTag } from '@swf/core/enums';

export enum BonusType {
  FreeSpin = 'FREE_SPINS_BONUS',
  SpinOfTheDay = 'SPIN_OF_THE_DAY_BONUS'
}

export enum BonusStatus {
  Available = 'BONUS_AVAILABLE_TO_PLAY',
  Playing = 'BONUS_PLAYING',
  Completed = 'BONUS_COMPLETED',
  Expired = 'BONUS_EXPIRED'
}

export interface CasinoBonusGame {
  bonusId: string;
  bonusCampaignId: string;
  gameURL: ResolverTag;
}

export interface SpinOfDayData extends CasinoBonusGame {
  status: BonusStatus;
  numberOfTickets: number;
  expiryTime: number;
}
